/**
 * @file 注册页模板
 */
import { buildImage } from '@/utils/action-lib'
import { getStore } from '@/store/store-standard'
import { Tracker } from '@/utils/event-lib'
import { isMgm } from '@/utils/dom'
import useI18n from '@/i18n/landing'
const $i18n = useI18n()

const protocolTpl = `<div class="protocol-box">
  <div class="tick_box" data-action="protocol">
    <div class="wave_circle"></div>
    <div class="wave_fix"></div>
    <img class="gesture" style="display:none" src="${require('@/assets/images/gesture_img.png')}" />
  </div>
  <div data-action="agreement"></div>
</div>`

const buildNormalHeaderAndFooter = (data: PAGE_CONFIG) => {
  const backgrounds = data.reg_backgrounds.slice(0)
  const head = backgrounds.shift()
  if (head) {
    head.appendAttrs = 'onload="window.scrollTo(0,0)"'
  }
  const headTemplate = head
    ? `<div>${buildImage(head)}</div>`
    : ''
  const footTemplate = `<div style="padding-bottom:140px">
        ${backgrounds.map(buildImage).join('')}
    </div>`
  return [headTemplate, footTemplate]
}

const buildMGMHeaderAndFooter = (data: PAGE_CONFIG) => {
  try {
    const config = getStore('mgm')
    const {
      material: {
        share_page: { content, sub_title, pic },
      },
    } = config
    const headerTpl = `<div 
        class="register-header" 
      >
      <div class="logo"></div>
      <div class="title space">${content}</div>
      <div class="sub-title">${sub_title}</div>
      <img src="${pic}" width="100%" />
  </div>`
    // 这里为了上线时兼容线上，MGM头图配置中，第一张自动舍弃，从第二张开始展示
    const backgrounds = data.reg_backgrounds.slice(1)
    const footTemplate = `<div style="padding-bottom:140px">
        ${backgrounds.map(buildImage).join('')}
    </div>`
    return [headerTpl, footTemplate]
  } catch (e: any) {
    Tracker.trackWithRaven('MGMTemplateError', {
      e: e.toString(),
    })
    // 如果没有拿到配置，则返回兜底模板
    return buildNormalHeaderAndFooter(data)
  }
}

export default (data: PAGE_CONFIG) => {
  // 注册模块
  const coreTemplate = `<div class="register-page-box" id="js_reg_box">
  <div class="inner" id="js_inner">
    <input class="register-number-box" id="tel" type="tel" maxlength="11" autocomplete="off" placeholder="${$i18n.t(
      'Fintech_Credit_users_Fgor_OikJ'
    )}" />
    <button data-action="login" class="next-btn">${$i18n.t(
      'financial.loan.freya.home.uncredit.apply_btn_new'
    )}</button>
      ${protocolTpl}
    </div>
  </div>`

  // 顶部配图和其他位置配图,MGM个性化处理
  const [headTemplate, footTemplate] = isMgm()
    ? buildMGMHeaderAndFooter(data)
    : buildNormalHeaderAndFooter(data)

  return `${headTemplate}${coreTemplate}${footTemplate}`
}
